export const stateStrategy = {
  registered: 'registered',
  qualifying: 'qualifying',
  qualifying_management_review: 'qualifying',
  qualifying_finantial_review: 'qualifying',
  quoting: 'quoting',
  quoting_management_review: 'quoting',
  quoting_client_review: 'quoting',
  quoting_finalization: 'negotiating',
  negotiating: 'completed',
  completed: 'completed'
} as const


export const translateStateStrategy = {
  registered: 'Registrado',
  qualifying: 'Qualificando',
  quoting: 'Cotação',
  negotiating: 'Contrato',
  completed: 'Concluído'
}

export const contactStateStrategy = {
  pending: 'pending',
  awaiting_client_documents: 'awaiting_client_documents',
  in_review: 'in_review',
  complete: 'complete'
} as const

export const translateContactStateStrategy = {
  pending: 'Pendente',
  awaiting_client_documents: 'Aguardando Resposta',
  in_review: 'Revisar',
  complete: 'Completo'
}
